import axios from "axios";
import Vue from "vue";
import Cookies from 'js-cookie'
import { defaultLang } from '@/i18n'
import i18n from '@/i18n'
// import NProgress from 'nprogress'

import router from "../../router/index";

import { Loading } from "element-ui";

//gq
// axios.defaults.baseURL = 'http://172.16.190.41:8081/'
// // lxh
// axios.defaults.baseURL = 'http://172.16.190.100:8081/'
// // hn
// axios.defaults.baseURL = 'http://172.16.110.244:8083/'
//hzm
// axios.defaults.baseURL = 'http://172.16.190.161:8082/'

// ceshi
// axios.defaults.baseURL = 'https://172.16.1.56:11022/'
let loadingInstance;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// 请求头拦截
axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = Cookies.get('language') || defaultLang
    let token = window.sessionStorage.getItem("token");
    config.headers.ClientId = "customer-app";
    if (token) {
        config.headers.Authorization = token;
    }
    const notLoadingUrl = ['cmUser/message2/unReadCount', 'shopping/vehicle/queryAmountsPayable', 'shopping/vehicle/querySaveTime']
    if (config.headers.isCurLoad) {
        return config
    }
    // NProgress.start();
    if (!notLoadingUrl.includes(config.url)) {
        loadingInstance = Loading.service({
            fullscreen: true,
            background: "rgba(0, 0, 0, 0.8)",
            text: i18n.t('loading'),
        });
    }
    return config;
});
/* 响应拦截器 */
axios.interceptors.response.use(
    function (response) {
        if (response.data.code === 401) {
            window.sessionStorage.removeItem("token"); // 删除已经失效或过期的token
            router.replace({
                path: "/login",
            });
        }
        if (
            loadingInstance &&
            response.config.url != "cmUser/message/unReadCount"
        ) {
            loadingInstance.close();
        }
        return response;
    },
    function (error) {
        loadingInstance && loadingInstance.close();
        return Promise.reject(error);
    }
);
Vue.prototype.$http = axios;

export default axios;
